<template>
  <div v-if="show" class="modal-overlay" @click.self="handleClose">
    <!-- ip限制弹窗 -->
    <div class="modal-card">
      <div class="modal-header">
        <h3 class="modal-title">Service Restriction</h3>
        <img
          class="close-icon"
          src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-10Popde2.png"
          alt=""
          @click="handleClose"
        />
      </div>
      <p class="modal-desc">
        This service is temporarily unavailable for international addresses.
        Please check back later.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelpModal",
  props: {
    // type: {
    //   type: Number,
    //   default: 0,
    // },
  },
  data() {
    return {
      show: 0,
      originalBodyOverflow: "", // 保存原始 overflow 值
    };
  },
  mounted() {
    // 如果组件创建时 也需要禁止滚动（但一般初始为 false）
    if (this.type) {
      this.disableBodyScroll();
    }
  },
  beforeDestroy() {
    // 组件销毁前确保恢复滚动（防止组件被强行移除时滚动仍被禁用）
    this.enableBodyScroll();
  },
  watch: {
    // 监听弹窗显示状态，控制body滚动
    show(val) {
      if (val) {
        // 弹窗显示：禁止背景滚动
        this.disableBodyScroll();
      } else {
        // 弹窗隐藏：恢复背景滚动
        this.enableBodyScroll();
      }
    },
  },
  mounted() {
    // 组件挂载时，禁止body滚动
    if (this.show) {
      this.disableBodyScroll();
    }
  },
  beforeDestroy() {
    // 组件销毁时，恢复body滚动
    this.enableBodyScroll();
  },
  methods: {
    open() {
      this.show = true;
    },
    /**
     * 关闭弹窗
     * 触发 close 事件通知父组件
     */
    handleClose() {
      this.show = false;
    },
    disableBodyScroll() {
      // 保存当前 body 的 overflow 样式（可能为空或已有值）
      this.originalBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    },
    enableBodyScroll() {
      // 恢复原来的 overflow 样式
      document.body.style.overflow = this.originalBodyOverflow;
      // 清除保存的值（可选）
      this.originalBodyOverflow = "";
      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@media all and (min-width: 768px) {
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    box-sizing: border-box;
    z-index: 9999;
    overflow-y: auto;

    .modal-card {
      width: 100%;
      max-width: 68.75rem;
      background: #ffffff;
      border-radius: 1.25rem;
      padding: 2rem;
      box-sizing: border-box;
      animation: modalSlideIn 0.3s ease-out;
      max-height: 90vh;
      overflow-y: auto;

      .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 1rem;

        .modal-title {
          font-size: 1.875rem;
          font-weight: 600;
          color: #0074fc;
          margin: 0;
          flex: 1;
          padding-right: 1rem;
        }

        .close-icon {
          width: 1.875rem;
          height: 1.875rem;
          cursor: pointer;
          flex-shrink: 0;
          transition: opacity 0.2s;

          &:hover {
            opacity: 0.7;
          }
        }
      }

      .modal-desc {
        font-size: 1.25rem;
        color: #333333;
        font-weight: 400;
        color: #101424;
        line-height: 2rem;
        margin-bottom: 1.5rem;
      }

      .table-container {
        background: #fff;
        overflow: hidden;

        .info-table {
          font-size: 1.2rem;
          width: 100%;
          border-spacing: 0;
          border-radius: 1.25rem;
          overflow: hidden;
          border: 1px solid rgba(0, 116, 252, 0.5);

          thead {
            margin: 0;
            padding: 0;
            tr {
              background: #e3f0ff;

              th {
                padding: 1rem 1.5rem;
                padding-left: 5rem;
                text-align: left;
                font-weight: 600;
                color: #0074fc;
                border-bottom: 1px solid #f5f6fe;
              }

              th:first-child {
                width: 25%;
                border-right: 1px solid #f5f6fe;
              }
            }
          }

          tbody {
            margin: 0;
            padding: 0;
            tr {
              border-bottom: 1px solid #f5f6fe;

              &:last-child {
                border-bottom: none;
              }

              td {
                padding: 1rem 1.5rem;
                padding-left: 5rem;
                border-bottom: 1px solid #f5f6fe;
                border-right: 1px solid #f5f6fe;
                font-size: 1.2rem;
                color: #333333;
                line-height: 1.6;
              }

              td:first-child {
                color: #666666;
                font-weight: 500;
              }
            }
          }
        }
      }

      .highlight-box {
        background: #e8f4ff;
        border-radius: 0.75rem;
        padding: 1.5rem;
        text-align: center;
        font-size: 1.4rem;
        color: #0074fc;
        font-weight: 500;
      }
    }
  }
}
@media (max-width: 767px) {
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    box-sizing: border-box;
    z-index: 9999;
    overflow-y: auto;

    .modal-card {
      width: 38rem;
      background: #ffffff;
      border-radius: 1.25rem;
      padding: 2rem;
      box-sizing: border-box;
      animation: modalSlideIn 0.3s ease-out;
      max-height: 90vh;
      overflow-y: auto;

      .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 1rem;

        .modal-title {
          font-size: 1.875rem;
          font-weight: 600;
          color: #0074fc;
          margin: 0;
          flex: 1;
          padding-right: 1rem;
        }

        .close-icon {
          width: 2rem;
          height: 2rem;
          margin-top: 0.5rem;
          cursor: pointer;
          flex-shrink: 0;
          transition: opacity 0.2s;

          &:hover {
            opacity: 0.7;
          }
        }
      }

      .modal-desc {
        font-size: 1.4rem;
        color: #333333;
        font-weight: 400;
        color: #101424;
        line-height: 2rem;
        margin-bottom: 1.5rem;
      }

      .table-container {
        background: #fff;
        overflow: hidden;

        .info-table {
          font-size: 1.4rem;
          width: 100%;
          border-spacing: 0;
          border-radius: 1.5rem;
          overflow: hidden;
          border: 1px solid rgba(0, 116, 252, 0.5);

          thead {
            margin: 0;
            padding: 0;
            tr {
              background: #e3f0ff;

              th {
                padding: 1rem;
                // padding-left: 5rem;
                text-align: center;
                font-weight: 600;
                color: #0074fc;
                border-bottom: 1px solid #f5f6fe;
              }

              th:first-child {
                text-align: center;
                width: 30%;
                border-right: 1px solid #f5f6fe;
              }
            }
          }

          tbody {
            margin: 0;
            padding: 0;
            tr {
              text-align: center;
              border-bottom: 1px solid #f5f6fe;

              &:last-child {
                text-align: center;
                border-bottom: none;
              }

              td {
                padding: 1rem 1.5rem;
                text-align: center;
                border-bottom: 1px solid #f5f6fe;
                border-right: 1px solid #f5f6fe;
                font-size: 1.4rem;
                color: #333333;
                line-height: 1.6;
              }

              td:first-child {
                text-align: center;
                color: #666666;
                font-weight: 500;
              }
            }
          }
        }
      }

      .highlight-box {
        background: #e8f4ff;
        border-radius: 0.75rem;
        padding: 1.5rem;
        text-align: center;
        font-size: 1.4rem;
        color: #0074fc;
        font-weight: 500;
      }
    }
  }
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>